<div
  class="tw-border-2 tw-cursor-pointer tw-border-gray-300 tw-relative tw-border-dashed img-hover tw-group tw-rounded-lg"
  [ngClass]="imageUploaderSize"
>
  <!-- logo  -->
  <div
    *ngIf="imageSrc && !imageLoading"
    class="tw-flex-center img-hover tw-relative tw-group tw-h-full"
  >
    <!-- delete and add btn -->
    <div class="tw-absolute -tw-top-5 tw-left-4 tw-flex-center">
      <!-- delete image btn -->
      <div
        [matTooltip]="'common.delete' | translate"
        class="tw-bg-red-500 hover:tw-bg-red-600 tw-rounded-full tw-flex-center tw-cursor-pointer"
        [ngClass]="isShowAddBtn ? 'tw-w-9 tw-h-9 tw-mx-3' : ' tw-w-11 tw-h-11'"
      >
        <!-- delete btn -->
        <i
          class="mdi mdi-delete"
          [ngClass]="isShowAddBtn ? 'mdi-22px' : 'mdi-25px'"
          style="color: white !important"
          (click)="deleteImage()"
        ></i>
      </div>

      <!-- add image btn -->
      <div
        *ngIf="isShowAddBtn"
        [matTooltip]="'common.add' | translate"
        (click)="addNewImageUploaderField()"
        [ngClass]="
          isDisableAddBtn
            ? 'tw-bg-[#b1e8c5] dark:tw-bg-[#315740] tw-cursor-not-allowed'
            : 'tw-cursor-pointer hover:tw-bg-green-600 tw-bg-green-500 dark:tw-bg-green-600 dark:hover:tw-bg-green-700'
        "
        class="tw-rounded-full tw-flex-center tw-w-9 tw-h-9"
      >
        <!-- add btn -->
        <i class="mdi mdi-plus mdi-22px" style="color: white !important"></i>
      </div>
    </div>

    <!-- logo -->
    <img
      [imageViewer]="true"
      [src]="imageSrc"
      alt="img"
      class="tw-w-full tw-h-full tw-p-2 tw-object-contain"
    />
  </div>

  <!-- image uploader -->
  <div *ngIf="!imageSrc" (click)="fileInput.click()">
    <input
      type="file"
      hidden
      #fileInput
      accept=".jpg,.jpeg,.png"
      (input)="onCheckFile($event)"
    />
    <div
      ngxMatFileInputIcon
      class="m-0 tw-absolute uploader tw-top-0 tw-right-0"
      [ngClass]="imageUploaderSize"
    >
      <div *ngIf="!imageLoading" class="tw-flex-center tw-flex-col tw-h-full">
        <i class="mdi mdi-48px mdi-cloud-upload" after-label></i>
        <span
          *ngIf="imageUploaderTitle && !imageSrc"
          class="tw-mt-[5px] tw-text-gray-400 tw-font-bold tw-text-lg"
          >{{ imageUploaderTitle | translate }}</span
        >
      </div>
    </div>
  </div>

  <!-- loading -->
  <div
    *ngIf="imageLoading"
    class="tw-h-full tw-w-full tw-flex-center tw-top-0 tw-absolute"
  >
    <div
      class="spinner-border tw-text-gray-300 tw-mr-1 tw-w-[20px] tw-h-[20px] tw-ml-[3px] ltr:tw-mr-[3px]"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>
